import React, {FC} from 'react'
export const SimpleTableOptions: FC = () => {
  return <h5>There is nothing to configure here</h5>
}
